import type { Translation } from '../i18n-types';

const es: Translation = {
  userGuide: 'Guía de Usuario',
  privacyPolicy: 'Política de Privacidad',
  termsConditions: 'Términos y Condiciones',
  support: 'Soporte',
  abandoned: 'Abandonado',
  completed: 'Completado',
  cancelled: 'Cancelado',
  ended: 'Finalizado',
  actionComments: 'Comentarios de Acción',
  actionItem: 'Item de Acción',
  actionItemPlaceholder: 'Item de acción...',
  actionItems: 'Items de Acción',
  actionPhaseDescription: 'Añadir elementos de acción, ya no se pueden agrupar ni votar comentarios',
  actions: 'Acciones',
  activate: 'Activar',
  active: 'Activo',
  activeRetros: 'Retros activos',
  activeRetroUsers: 'Usuarios Activos de Retro',
  activeStoryboards: 'Storyboards Activos',
  activeStoryboardUsers: 'Usuarios activos de Storyboard',
  addComment: 'Añadir Comentario',
  addPersona: 'Añadir Persona',
  admin: 'Admin',
  adminCleanOldRetros: 'Limpiar Retros anteriores a {daysOld} días',
  adminCleanOldStoryboards: 'Limpiar Storyboards con más de {daysOld} días de antigüedad',
  adminPageAdmin: 'Admin',
  adminPageAlerts: 'Alertas',
  adminPageApi: 'Claves API',
  adminPageOrganizations: 'Organizaciones',
  adminPageTeams: 'Equipos',
  adminPageUsers: 'Usuários',
  adminPageSubscriptions: 'Suscripciones',
  deleteSubscriptionConfirmation: '¿Está seguro de que desea eliminar esta suscripción?',
  deleteSubscription: 'Eliminar suscripción',
  alertAllowDismiss: 'Permitir Descartar',
  alertContent: 'Contenido de Alerta',
  alertContentPlaceholder: 'Introducir el contenido de la alerta',
  alertCreate: 'Crear Alerta',
  alertDelete: 'Eliminar Alerta',
  alertDeleteConfirmation: '¿Estás seguro de que quieres eliminar esta alerta?',
  alertNamePlaceholder: 'Introduzca un nombre de alerta',
  alertRegisteredOnly: 'Sólo inscritos',
  alerts: 'Alertas',
  alertSave: 'Guardar Alerta',
  alertTypePlaceholder: 'Seleccione un tipo de alerta',
  allVotesIn: 'Todos los votos en',
  apiDocumentation: 'Documentación API',
  apikeyCopyFailure: 'No se ha podido copiar la clave API en el portapapeles',
  apikeyCopySuccess: 'Clave API copiada en el portapapeles',
  apiKeys: 'Claves API',
  applicationStatsError: 'Error al obtener las estadísticas de la aplicación',
  appName: 'Thunderdome',
  appPreviewAlt: 'Prévia de Thunderdome, un Planning Poker Ágil con UI',
  appSubtitle: 'Aplicación de código abierto Agile Planning Poker app',
  appVersion: 'versión {version}',
  associateTeam: 'Equipo asociado',
  authError: 'Se ha producido un error al intentar autenticar al usuario',
  autoFinishVoting: 'Votación automática',
  avatarAltText: 'Placeholder Avatar',
  back: 'Volver',
  battleAbandon: 'Abandonar el Juego',
  battleCreate: 'Crear Juego',
  battleDelete: 'Eliminar Juego',
  battleEdit: 'Editar Juego',
  battleEditPointsDisabled: 'La votación está activa, no puede modificar los puntos permitidos.',
  battleJoin: 'Unirse al juego',
  battleName: 'Nombre del juego',
  battleRemoveError: 'Error al intentar eliminar el juego.',
  battleRemoveSuccess: 'Juego eliminado con éxito.',
  battles: 'Juegos',
  battlesActive: 'Juegos Activos',
  battlesActiveUsers: 'Usuarios Activos del Juego',
  becomeFacilitator: 'Conviértase en Facilitador',
  becomeParticipant: 'Convertirse en Participante',
  becomeSpectator: 'Conviértase en Espectador',
  blocked: 'Bloqueado',
  blockers: 'Bloqueadores',
  blockersPlaceholder: 'Estoy bloqueado por...',
  brainstorm: 'Lluvia de ideas',
  brainstormPhaseDescription: 'Añada sus comentarios',
  brainstormPhaseFeedbackVisibility: 'Fase de lluvia de ideas Feedback Visibilidad',
  brainstormVisibilityLabelConcealed: 'Feedback Escondido',
  brainstormVisibilityLabelHidden: 'Feedback Oculto',
  brainstormVisibilityLabelVisible: 'Feedback Visible',
  cancel: 'Cancelar',
  cannotBeUndone: 'Esto no se puede deshacer.',
  checkIn: 'Registro de entrada',
  checkinCommentDeleteError: 'Error al eliminar un comentario',
  checkinCommentError: 'Error al hacer el registro de entrada',
  checkinError: 'Comprobación de errores en',
  checkinMeetYesterdayGoalsQuestion: '¿Cumplió los objetivos de ayer?',
  checkins: 'Registros',
  colorLegend: 'Leyenda de colores',
  colorLegendNotSpecified: 'leyenda no especificada',
  comment: 'Comentario',
  comments: 'Comentarios',
  conciseVotingResults: 'Resultados Concisos de la Votación',
  confirmDeleteRetro: '¿Seguro que quieres eliminar esta retrospectiva?',
  createAccount: 'Crear cuenta',
  createAccountTagline: `¿No tienes una cuenta?`,
  createAlertError: 'Error al crear la alerta',
  createAlertSuccess: 'Alerta creada correctamente',
  createARetro: 'Crear una Retro',
  createAStoryboard: 'Crear un Storyboard',
  createBattleError: 'Error al crear el juego',
  createOrgError: 'Error al intentar crear una organización',
  createRetro: 'Crear Retro',
  createRetroErrorMessage: 'Error al crear retro',
  createStoryboard: 'Crear Storyboard',
  createUserError: 'Error al crear usuario',
  customizableBattleOptions: 'Opciones de juego personalizables',
  dateCreated: 'Fecha de creación',
  dateUpdated: 'Fecha de actualización',
  delete: 'Eliminar',
  deleteActionItemError: 'Error al eliminar una acción',
  deleteActionItemSuccess: 'Acción eliminada correctamente',
  deleteAlertError: 'Error al intentar eliminar una alerta',
  deleteAlertSuccess: 'Alerta eliminada correctamente',
  deleteBattle: 'Eliminar juego',
  deleteBattleConfirmText: '¿Estás seguro de que quieres eliminar este juego?',
  deleteBattleError: 'error al eliminar el juego',
  deleteCheckinError: 'Error al eliminar el registro',
  deleteDepartment: 'Eliminar Departamento',
  deleteDepartmentConfirmText: '¿Seguro que quieres eliminar este departamento?',
  deleteOrganization: 'Eliminar organización',
  deleteOrganizationConfirmText: '¿Está seguro de que desea eliminar esta organización?',
  deleteRetro: 'Eliminar Retro',
  deleteRetroErrorMessage: 'error al eliminar retro',
  deleteStoryboard: 'Eliminar Storyboard',
  deleteStoryboardErrorMessage: 'error al eliminar storyboard',
  deleteTeam: 'Eliminar Equipo',
  deleteTeamConfirmText: '¿Seguro que quieres borrar este equipo?',
  deleteUserError: 'Error al eliminar un usuario',
  demote: 'Degradar',
  demoteUserError: 'Error al degradar un usuario',
  department: 'Departamento',
  departmentCreate: 'Crear Departamento',
  departmentCreateError: 'Error al intentar crear un departamento',
  departmentDeleteError: 'Error al intentar eliminar un departamento',
  departmentDeleteSuccess: 'Departamento eliminado con éxito.',
  departmentGetError: 'Error al obtener el departamento',
  departmentName: 'Nombre del departamento',
  departmentNamePlaceholder: 'Introduzca un nombre de departamento',
  departments: 'Departamentos',
  departmentSave: 'Guardar Departamento',
  departmentTeamsGetError: 'Error al obtener equipos de departamento',
  departmentUsersGetError: 'Error al obtener usuarios del departamento',
  discuss: 'Discutir',
  discussPlaceholder: 'Me gustaría discutir...',
  done: 'Hecho',
  duplicateRetroSession: 'Existe una sesión retro duplicada para su ID',
  duplicateStoryboardSession: 'Existe una sesión de storyboard duplicada para su ID',
  edit: 'Editar',
  editColorLegend: 'Editar leyenda',
  editRetro: 'Editar Retro',
  editStoryboard: 'Editar Storyboard',
  email: 'Email',
  enterPasscode: 'Introduzca el código de acceso...',
  enterYourEmail: 'Introduzca su dirección de correo electrónico',
  execute: 'Ejecute',
  export: 'Exportar',
  facilitator: 'Facilitador',
  facilitatorCode: 'Código del facilitador',
  facilitatorCodeOptional: 'Código del facilitador (opcional)',
  facilitatorCodePlaceholder: 'Introduzca un código de facilitador opcional',
  finalPoints: 'Puntos finales',
  flag: 'Bandera',
  footerAuthoredBy: 'Creado con ❤️ por {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: '¿Ha olvidado su contraseña?',
  forgotPasswordSubtext: `No se preocupe. Solo tienes que introducir tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.`,
  returnToLogin: 'Volver al inicio de sesión',
  getAlertsError: 'Error al recibir alertas',
  getApikeysError: 'Error al obtener apikeys',
  getBattleError: 'Error al acceder al juego',
  getBattlesError: 'Error al acceder a los juegos',
  getCheckinsError: 'Error al registrar',
  getOrganizationsError: 'Error al obtener organizaciones',
  getRetroErrorMessage: 'error al obtener retro',
  getRetrosErrorMessage: 'error al obtener las retro',
  getStoryboardErrorMessage: 'error al obtener el storyboard',
  getStoryboardsErrorMessage: 'error al obtener los storyboards',
  getTeamsError: 'Error al obtener equipos',
  getUserError: 'Error al obtener el usuario',
  getUsersError: 'Error al obtener los usuarios',
  goalsMet: 'Objetivos alcanzados',
  group: 'Grupo',
  groupName: 'Nombre del grupo',
  groupPhaseDescription: 'Arrastre y suelte los comentarios para agruparlos',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} es un servicio alojado gratuito (SaaS) sin anuncios.',
  hostedOrSelfHosted: 'Servicio alojado o autoalojado',
  importCsv: 'Importar historias desde un archivo CSV',
  importCsvFileBadFileTypeError: 'Error tipo de archivo incorrecto',
  importCsvFileReadFileError: 'Error al leer el archivo',
  importJiraXML: 'Importar historias desde Jira XML',
  importJiraXMLBadFileTypeError: 'Error tipo de archivo incorrecto',
  importJiraXMLReadFileError: 'Error al leer el archivo',
  incorrectPassCode: 'Código de acceso incorrecto',
  inviteLinkCopyFailure: 'No se ha podido copiar el enlace de invitación al portapapeles',
  inviteLinkCopySuccess: 'Enlace de invitación copiado en el portapapeles',
  jiraXmlImport: 'Importación XML de Jira',
  joinCodeCopyFailure: 'No se puede copiar el código de acceso al portapapeles',
  joinCodeCopySuccess: 'Código de acceso copiado en el portapapeles',
  joinCodeLabelOptional: 'Código de acceso (opcional))',
  joinCodePlaceholder: 'Introduzca un código de acceso',
  joinRetro: 'Únete a Retro',
  joinStoryboard: 'Únete al Storyboard',
  joinStoryboardError: 'Error al unirse al storyboard, actualice e inténtelo de nuevo.',
  landingCountries: 'Usuarios en más de {count} países',
  landingFeatureOpenSourceText:
    'Echa un vistazo al {repoOpen}Repositorio Github{repoClose} para solicitar o aportar mejoras, traducciones a otros idiomas y correcciones de errores o para {donateOpen}Donar{donateClose}.',
  landingFeatureOpenSourceTitle: 'Código abierto',
  landingSalesPitch:
    'Colaboración remota en equipo con puntuación de historias agiles, print restrospectiva, mapeo de historias y registro asíncrono de equipos.',
  landingTitle: 'TThunderdome es una aplicación de póquer de planificación ágil',
  lastActive: 'Último activo',
  leaveRetro: 'Abandonar Retro',
  leaveStoryboard: 'Abandonar Storyboard',
  legendRetroPlaceholder: 'Introduzca una leyenda de color',
  loadingRetro: 'Cargando Retro...',
  loadingStoryboard: 'Cargando Storyboard...',
  login: 'Login',
  loginForRetro: 'o {loginOpen}Login{loginClose} para unirse a Retro',
  loginForStoryboard: 'o {loginOpen}Login{loginClose} para unirse al Storyboard',
  logout: 'Salir',
  logoutError: 'Se ha producido un error al intentar cerrar la sesión del usuario',
  makeFacilitator: 'Hacer de facilitador',
  mfa2faLabel: 'Autenticación 2FA/MFA',
  mfa2faRemove: 'Eliminar 2FA/MFA',
  mfa2faRemoveFailure: 'Error al eliminar 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA eliminado con éxito',
  mfa2faRemoveText: '¿Estás seguro de que quieres eliminar 2FA/MFA?',
  mfa2faSetup: 'Configurar 2FA/MFA',
  mfaAuthError: 'Error al validar el autentificador',
  mfaConfirmToken: 'Confirmar Token',
  mfaGenerateFailed: 'fallo al iniciar la configuración 2FA/MFA',
  mfaSecretKeyLabel: 'Clave secreta',
  mfaSetupFailed: 'fallo al validar el token de configuración 2FA/MFA',
  mfaSetupIntro:
    'Escanee el siguiente código QR con una aplicación de autenticación (como Google Authenticator o Authy) e introduzca el token generado.',
  mfaSetupSuccess: '2FA/MFA activado correctamente',
  mfaTokenLabel: 'Token autenticador',
  mfaTokenPlaceholder: 'Introduzca el token de la aplicación de autenticación',
  myRetros: 'Mis Retros',
  myStoryboards: 'Mis Storyboards',
  name: 'Nombre',
  needsImprovement: 'Necesita mejorar',
  nextPhase: 'Siguiente fase',
  noComments: 'Sin comentarios...',
  oldBattleCleanError: 'Error al limpiar los juegos',
  oldGuestsCleanError: 'Error al limpiar los invitados',
  oldRetrosCleanError: 'Error en la limpieza de retros',
  oldStoryboardsCleanError: 'Error al limpiar storyboards',
  openSource: 'Código abierto',
  optional: '(Opcional)',
  optionalLeadercodePlaceholder: 'Código de líder opcional para convertirse en líder',
  optionalPasscodePlaceholder: 'Código de acceso opcional',
  organization: 'Organización',
  organizationCreate: 'Crear organización',
  organizationDeleteError: 'Error al intentar eliminar una organización',
  organizationDeleteSuccess: 'Organización eliminada con éxito.',
  organizationGetDepartmentsError: 'Error al obtener los departamentos de la organización',
  organizationGetError: 'Error al obtener la organización',
  organizationGetTeamsError: 'Error al obtener equipos de organización',
  organizationGetUsersError: 'Error al obtener usuarios de la organización',
  organizationName: 'Nombre de la organización',
  organizationNamePlaceholder: 'Introduzca el nombre de la organización',
  organizations: 'Organizaciones',
  organizationsAndTeams: 'Organizaciones y equipos',
  organizationSave: 'Guardar Organización',
  owner: 'Propietario',
  participation: 'Participación',
  passCode: 'Código',
  passCodeRequired: 'Código de acceso obligatorio',
  personas: 'Personas',
  planAcceptanceCriteria: 'Criterios de aceptación',
  planAcceptanceCriteriaPlaceholder: 'Introducir criterios de aceptación',
  planAdd: 'Añadir historias',
  planDescription: 'Descripción',
  planDescriptionPlaceholder: 'Introduzca una descripción',
  planLink: 'Enlace',
  planLinkInvalid: 'El enlace no es una URL absoluta válida, por ejemplo, incluye el protocolo (HTTP/HTTPS)',
  planLinkPlaceholder: 'Introduzca un enlace a la historya',
  planName: 'Nombre de la historia',
  planNamePlaceholder: 'Introduzca el nombre de la historia',
  planPriority: 'Prioridad',
  planPriorityBlocker: 'Bloqueador',
  planPriorityHigh: 'Alta',
  planPriorityHighest: 'Más alta',
  planPriorityLow: 'Baja',
  planPriorityLowest: 'Más baja',
  planPriorityMedium: 'Media',
  planPriorityPlaceholder: 'Selecciona una prioridad',
  planReferenceId: 'ID de Referencia',
  planReferenceIdPlaceholder: 'Ingresa un ID de referencia',
  plans: 'Historias',
  planSkip: 'Omitir Historia',
  planType: 'Tipo de Historia',
  planTypeBug: 'Error',
  planTypeEpic: 'Épico',
  planTypePlaceholder: 'Tipos',
  planTypeSpike: 'Investigación',
  planTypeStory: 'Historia',
  planTypeSubtask: 'Subtarea',
  planTypeTask: 'Tarea',
  pointAverageRounding: 'Redondeo Promedio de Puntos',
  pointed: 'Puntuado ({count})',
  points: 'Puntos',
  pointValuesAllowed: 'Valores de Puntos Permitidos',
  postComment: 'Publicar Comentario',
  primeDirective: 'Directiva Principal',
  promote: 'Promocionar',
  promoteUserError: 'Error al promocionar al usuario',
  questions: 'Preguntas',
  register: 'Registrar',
  reloadingRetro: 'Ups, recargando Retro...',
  reloadingStoryboard: 'Ups, recargando Storyboard...',
  remove: 'Eliminar',
  removeBattle: 'Eliminar Juego',
  removeBattleConfirmText: '¿Seguro que deseas eliminar este juego?',
  removeRetro: 'Eliminar Retro',
  removeRetroConfirmText: '¿Seguro que deseas eliminar este retro?',
  removeStoryboard: 'Eliminar Storyboard',
  removeStoryboardConfirmText: '¿Seguro que deseas eliminar este storyboard?',
  removeUser: 'Eliminar Usuario',
  removeUserConfirmText: '¿Seguro que deseas eliminar a este usuario?',
  requestVerifyEmail: 'Solicitar Correo de Verificación',
  requestVerifyEmailFailure: 'Error al intentar enviar el Correo de Verificación',
  requestVerifyEmailSuccess: 'Correo de Verificación solicitado, revisa tu bandeja de entrada',
  retro: 'Retro',
  retroActionCommentAddError: 'error al agregar comentario de acción retro',
  retroActionCommentDeleteError: 'error al eliminar comentario de acción retro',
  retroActionCommentEditError: 'error al editar comentario de acción retro',
  retroActionItems: 'Elementos de Acción Retro',
  retroAddError: 'Error al intentar agregar retro.',
  retroAddSuccess: 'Retro agregado con éxito.',
  retroDeleted: 'Retro eliminado',
  retroFeedbackConcealed: 'Comentarios Escondidos',
  retroFeedbackHidden: 'Comentarios Ocultos',
  retroImprovePlaceholder: 'Qué necesita mejorar...',
  retroItems: 'Elementos Retro',
  retroJoinError: 'Error al unirse al retro, actualiza y vuelve a intentarlo.',
  retroMaxVotesPerUserLabel: 'Votos Máximos del Grupo (por Usuario)',
  retroName: 'Nombre de la Retro',
  retroNamePlaceholder: 'Ingresa un nombre para la retro',
  retroQuestionPlaceholder: 'Quiero preguntar...',
  retroRemoveError: 'Error al intentar eliminar el retro.',
  retroRemoveSuccess: 'Retro eliminado con éxito.',
  retros: 'Retros',
  retroWorkedPlaceholder: 'Qué funcionó bien...',
  role: 'Rol',
  rolePlaceholder: 'Selecciona el rol del usuario',
  save: 'Guardar',
  search: 'Buscar',
  searchLengthError: 'El valor de búsqueda debe tener al menos 3 caracteres',
  selectTeam: 'Selecciona un Equipo',
  selfHostedDesc: 'Alternativamente, puedes {linkOpen}ejecutarlo en tu propio servidor{linkClose}.',
  sessionDuplicate: 'Existe una sesión de juego duplicada para tu ID',
  showActiveBattles: 'Mostrar Juegos Activos',
  showActiveRetros: 'Mostrar retros activos',
  showActiveStoryboards: 'Mostrar storyboards activos',
  showBlockedCheckins: 'Mostrar solo check-ins que requieren discusión',
  showCompletedActionItems: 'Mostrar Elementos de Acción Completados',
  showVoters: 'Mostrar Votantes',
  skipped: 'Omitido',
  spectator: 'Espectador',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Agregar Columna',
  storyboardAddError: 'Error al intentar agregar el storyboard.',
  storyboardAddGoal: 'Agregar Objetivo',
  storyboardAddStoryToColumn: 'Agregar Historia a la Columna',
  storyboardAddSuccess: 'Storyboard agregado con éxito.',
  storyboardColumns: 'Columnas del Storyboard',
  storyboardDeleted: 'Storyboard eliminado',
  storyboardEditColumn: 'Editar Columna',
  storyboardGoalName: 'Nombre del objetivo',
  storyboardGoalNamePlaceholder: 'Ingresa un nombre de objetivo',
  storyboardGoals: 'Objetivos del Storyboard',
  storyboardPersonas: 'Personas del Storyboard',
  storyboardRemoveError: 'Error al intentar eliminar el storyboard.',
  storyboardRemoveSuccess: 'Storyboard eliminado con éxito.',
  storyboards: 'Storyboards',
  storyboardStories: 'Historias del Storyboard',
  team: 'Equipo',
  teamCheckins: 'Check-ins del Equipo',
  teamCreate: 'Crear Equipo',
  teamCreateError: 'Error al intentar crear el equipo.',
  teamCreateSuccess: 'Equipo creado con éxito.',
  teamDeleteError: 'Error al intentar eliminar el equipo',
  teamDeleteSuccess: 'Equipo eliminado con éxito.',
  teamGetBattlesError: 'Error al obtener los juegos del equipo',
  teamGetError: 'Error al obtener el equipo',
  teamGetRetroActionsError: 'Error al obtener acciones retro',
  teamGetRetrosError: 'Error al obtener retros del equipo',
  teamGetStoryboardsError: 'Error al obtener storyboards del equipo',
  teamGetUsersError: 'Error al obtener los usuarios del equipo',
  teamName: 'Nombre del Equipo',
  teamNamePlaceholder: 'Ingresa un nombre de equipo',
  teams: 'Equipos',
  teamSave: 'Guardar Equipo',
  teamUserRequiredToCheckin: 'El usuario debe estar en el equipo para hacer check-in',
  teamUserRequiredToComment: 'El usuario debe estar en el equipo para comentar',
  today: 'Hoy',
  todayPlaceholder: 'Hoy voy a...',
  totalPoints: 'Total',
  totalVotes: 'Votos Totales',
  type: 'Tipo',
  unknownWarrior: 'Jugador Desconocido',
  unpointed: 'Sin puntos ({count})',
  updateActionItemError: 'Error al actualizar el elemento de acción',
  updateActionItemSuccess: 'Elemento de acción actualizado con éxito',
  updateAlertError: 'Error al intentar actualizar la alerta',
  updateAlertSuccess: 'Alerta actualizada con éxito',
  updateCheckinError: 'Error al actualizar el check-in',
  updateComment: 'Actualizar Comentario',
  userAdd: 'Agregar Usuario',
  userAddError: 'Error al intentar agregar usuario.',
  userAddSuccess: 'Usuario agregado con éxito.',
  userEmail: 'Correo del Usuario',
  userEmailPlaceholder: 'Ingresa el correo del usuario',
  userName: 'Nombre del Usuario',
  userRemoveError: 'Error al intentar eliminar usuario.',
  userRemoveSuccess: 'Usuario eliminado con éxito.',
  users: 'Usuarios',
  verifyAccount: 'Verificar Cuenta',
  verifyAccountFailedError:
    'Ocurrió un error al verificar tu cuenta; el enlace podría haber expirado o ya haber sido usado.',
  verifyAccountFailedTitle: 'Verificación Fallida',
  verifyAccountLoading: 'Verificando Cuenta...',
  verifyAccountVerifiedThanks: 'Gracias por verificar tu correo electrónico.',
  verifyAccountVerifiedTitle: 'Cuenta Verificada',
  view: 'Ver',
  vote: 'Votar',
  voteCount: 'Cantidad de Votos',
  votePhaseDescription: 'Vota por los grupos que deseas discutir más',
  voteResultsAverage: 'Promedio',
  voteResultsHighest: 'Más alto',
  votingFinish: 'Finalizar Votación',
  votingLocked: 'Votación Bloqueada',
  votingRestart: 'Reiniciar Votación',
  warriorCreate: 'Crear Usuario',
  warriorInvite: 'Invitar a un Jugador',
  warriorNudge: 'Empujar',
  works: 'Funciona',
  writeCommentPlaceholder: 'Escribe un comentario...',
  yesterday: 'Ayer',
  yesterdayPlaceholder: 'Ayer yo...',
  yourRetros: 'Tus Retros',
  yourStoryboards: 'Tus Storyboards',
  addPlan: 'Agregar Historia',
  battleNamePlaceholder: 'Ingresa un nombre de juego',
  autoFinishVotingLabel: 'Finalizar Votación Automáticamente cuando todos los Jugadores hayan votado',
  averageRoundingOptions: {
    ceil: 'Redondear hacia arriba',
    floor: 'Redondear hacia abajo',
    round: 'Redondear',
  },
  apiKeyCreateButton: 'Crear Clave API',
  apiKeyPrefix: 'Prefijo de Clave',
  lastUpdated: 'Última Actualización',
  apiKeysErrorRetrieving: 'Error al obtener claves API',
  apiKeyDeleteSuccess: 'Clave API eliminada',
  apiKeyDeleteFailed: 'Error al eliminar la clave API',
  apiKeyUpdateSuccess: 'Clave API actualizada',
  apiKeyUpdateFailed: 'Error al actualizar la clave API',
  deactivate: 'Desactivar',
  profileErrorRetrieving: 'Error al obtener tu perfil',
  profileErrorUpdating: 'Error al intentar actualizar tu perfil',
  profileUpdateSuccess: 'Perfil actualizado',
  passwordUpdated: 'Contraseña actualizada.',
  passwordUpdateError: 'Error al intentar actualizar la contraseña',
  profileDeleteError: 'Error al intentar eliminar tu cuenta.',
  profileTitle: 'Tu Perfil',
  profile: 'Perfil',
  updatePassword: 'Actualizar Contraseña',
  deleteAccount: 'Eliminar Cuenta',
  deleteAccountWarningStatement: '¿Estás seguro de que deseas eliminar tu cuenta?',
  deleteConfirmButton: 'Confirmar Eliminación',
  apiKeyNameInvalid: 'Por favor, ingresa un nombre de clave',
  apiKeyCreateSuccess: 'Nueva Clave API {keyName} creada y {onlyNowOpen}solo se mostrará ahora{onlyNowClose}',
  apiKeyStoreWarning:
    'Guárdala en un lugar seguro, ya que una vez que abandones esta página, no podremos recuperar o restaurar este token generado.',
  apiKeyLimitReached: 'Has alcanzado el número máximo de claves API permitidas.',
  apiKeyUnverifiedUser: 'Solo los usuarios registrados y verificados pueden crear claves API.',
  apiKeyCreateFailed: 'Failed to create API Key',
  apiKeyName: 'Nombre clave',
  apiKeyNamePlaceholder: 'Introduzca un nombre de clave',
  create: 'Crear',
  close: 'Cerrar',
  country: 'País',
  company: 'Empresa',
  verified: 'Verificado',
  registeredUsers: 'Usuarios Registrados',
  myBattles: 'Mis Juegos',
  createBattle: 'Crear Juego',
  countPlansPointed: '{totalPointed} de {totalPlans} historias puntuadas',
  myBattlesError: 'Error al encontrar tus juegos',
  warriorJoined: '{name} se ha unido al juego',
  warriorRetreated: '{name} ha salido del juego',
  planSkipped: 'Historia omitida',
  warriorVoted: '{name} ha votado',
  warriorRetractedVote: '{name} ha retirado el voto',
  battleDeleted: 'Juego eliminado',
  warriorNudgeMessage: 'pst... {name}, esperando tu voto.',
  battle: 'Juego',
  warriors: 'Jugadores',
  battleSocketReconnecting: 'Oops, recargando el Juego...',
  battleSocketError: 'Error al unirse al juego, actualiza e intenta de nuevo.',
  battleLoading: 'Cargando Juego...',
  votingNotStarted: 'Votación no iniciada',
  password: 'Contraseña',
  passwordPlaceholder: 'Ingresa una contraseña',
  yourPasswordPlaceholder: 'Ingresa tu contraseña',
  confirmPassword: 'Confirmar Contraseña',
  confirmPasswordPlaceholder: 'Confirma tu contraseña',
  update: 'Actualizar',
  reset: 'Restablecer',
  passwordResetError: 'Error al intentar restablecer la contraseña',
  resetPassword: 'Restablecer Contraseña',
  registerAsGuest: 'Registrarse como Invitado',
  registrationDisabled: 'Registro deshabilitado.',
  userNamePlaceholder: 'Ingresa tu nombre',
  guestRegisterError: 'Error al intentar registrarse como invitado',
  registerError: 'Error al intentar registrar la cuenta',
  enlistToBattle: 'Unirse a la Batalla',
  loginForBattle: 'o {loginOpen}Inicia Sesión{loginClose} para unirte al Juego',
  yourNamePlaceholder: 'Ingresa tu nombre',
  createAccountFormTitle: 'Crear una Cuenta {optionalOpen}(opcional){optionalClose}',
  sendResetPasswordSuccess: 'Instrucciones para restablecer la contraseña enviadas a {email}',
  sendResetPasswordError: 'Error al intentar enviar el restablecimiento de contraseña',
  chooseCountryPlaceholder: 'Elige tu país (opcional)',
  locale: 'Idioma',
  companyPlaceholder: 'Ingresa tu empresa (opcional)',
  jobTitle: 'Puesto de Trabajo',
  jobTitlePlaceholder: 'Ingresa tu puesto de trabajo (opcional)',
  enableBattleNotifications: 'Habilitar notificaciones de juego',
  avatar: 'Avatar',
  updateProfile: 'Actualizar Perfil',
  guestUsers: 'Usuarios Invitados',
  maintenance: 'Mantenimiento',
  cleanGuests: 'Eliminar Invitados con más de {daysOld} días',
  cleanBattles: 'Eliminar Juegos con más de {daysOld} días',
  chooseLocalePlaceholder: 'Elige tu idioma preferido (opcional)',
  importPlans: 'Importar Historias',
  selectFile: 'Seleccionar archivo...',
  theme: 'Tema',
  assignees: 'Asignados',
  assigneeSelectPlaceholder: 'Selecciona un asignado para agregar',
  assigneeAdd: 'Agregar Asignado',
  allStoryWithCount: 'Todos ({count})',
  userUpdate: 'Actualizar Usuario',
  userUpdateSuccess: 'Usuario actualizado con éxito.',
  userUpdateError: 'Error al actualizar el usuario.',
  userInvites: 'Invitaciones de Usuario',
  userInviteSent: 'Invitación de usuario enviada',
  userInviteConfirmDelete: '¿Estás seguro de que deseas eliminar esta invitación de usuario?',
  userInviteDelete: 'Eliminar Invitación',
  expireDate: 'Fecha de Expiración',
  addUserWillInviteNotFoundFieldNote:
    'Si el usuario no está registrado, se enviará una invitación para registrarse y unirse a la {pageType}.',
  inviteUserFieldNote: 'Se enviará una invitación para unirse a la {pageType}.',
  requiresOrganizationMember: 'El usuario debe estar en la Organización.',
  teamUpdateSuccess: 'Equipo actualizado con éxito',
  teamUpdateError: 'Error al actualizar el Equipo',
  orgUpdateSuccess: 'Organización actualizada con éxito',
  orgUpdateError: 'Error al actualizar la Organización',
  deptUpdateSuccess: 'Departamento actualizado con éxito',
  deptUpdateError: 'Error al actualizar el Departamento',
  hideVoterIdentity: 'Ocultar Identidad del Votante',
  storyboardName: 'Nombre del Storyboard',
  storyboardNamePlaceholder: 'Ingresa un nombre de storyboard',
  retroPhaseTimeLimitMinLabel: 'Límite de tiempo de la fase de lluvia de ideas en minutos',
  phaseAutoAdvanceLabel: 'Avanzar fases automáticamente',
  removeOnlyFacilitatorError: 'No se puede eliminar al único facilitador',
  noGamesFound: 'No se encontraron juegos, intenta crear uno.',
  noRetrosFound: 'No se encontraron retros, intenta crear uno.',
  noStoryboardsFound: 'No se encontraron storyboards, intenta crear uno.',
  retroDescription:
    'Una retrospectiva de sprint es una revisión realizada después de un sprint que desempeña un papel clave en la metodología Ágil. Su objetivo es determinar qué salió bien, dónde hubo problemas e identificar áreas de mejora.',
  pokerDescription:
    'El póker Scrum, también conocido como "póker de planificación" o "póker de puntos", es una técnica gamificada que los equipos de desarrollo utilizan para estimar el esfuerzo de tareas de gestión de proyectos. Estas estimaciones se basan en el aporte y consenso de todo el grupo, haciéndolas más atractivas y precisas que otros métodos.',
  storyboardDescription:
    'El mapeo de historias de usuario (storyboard) es una visualización del recorrido que un cliente realiza con un producto, desde el principio hasta el final. Incluye todas las tareas que completarían como parte de ese recorrido.',
  estimationScaleNamePlaceholder: 'Ingresa el nombre de la escala',
  description: 'Descripción',
  estimationScaleDescriptionPlaceholder: 'Ingresa la descripción de la escala',
  scaleType: 'Tipo de Escala',
  estimationScaleTypePlaceholder: 'Selecciona el tipo de escala',
  scaleValues: 'Valores de Escala',
  estimationScaleValuesPlaceholder: 'Ingresa valores separados por comas',
  estimationScaleValuesHelp: 'Ingresa valores separados por comas (e.g., 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Hacer esta escala pública',
  estimationScaleDefault: 'Establecer como escala predeterminada',
  estimationScaleSave: 'Guardar Escala',
  estimationScales: 'Escalas de Estimación',
  estimationScaleCreate: 'Crear Escala de Estimación',
  estimationScaleCreateSuccess: 'Escala de estimación creada con éxito',
  estimationScaleCreateError: 'Error al crear la escala de estimación',
  estimationScaleUpdateSuccess: 'Escala de estimación actualizada con éxito',
  estimationScaleUpdateError: 'Error al actualizar la escala de estimación',
  estimationScaleRemoveSuccess: 'Escala de estimación eliminada con éxito',
  estimationScaleRemoveError: 'Error al eliminar la escala de estimación',
  removeEstimationScaleConfirmText: '¿Estás seguro de que deseas eliminar esta escala de estimación?',
  removeEstimationScale: 'Eliminar Escala de Estimación',
  yes: 'Sí',
  no: 'No',
  isPublic: 'Público',
  default: 'Predeterminado',
  publicEstimationScales: 'Escalas de Estimación Públicas',
  organizationEstimationScales: 'Escalas de Estimación de la Organización',
  teamEstimationScales: 'Escalas de Estimación del Equipo',
  allowCumulativeVotingLabel: 'Permitir Votación Acumulativa (más de 1 voto por grupo de ítems)',
  activeSubscriptions: 'Suscripciones Activas',
  retroTemplates: 'Plantillas de Retrospectiva',
  publicRetroTemplates: 'Plantillas de Retrospectiva Públicas',
  organizationRetroTemplates: 'Plantillas de Retrospectiva de la Organización',
  teamRetroTemplates: 'Plantillas de Retrospectiva del Equipo',
  retroTemplateNamePlaceholder: 'Ingresa el nombre de la plantilla',
  retroTemplateDescriptionPlaceholder: 'Ingresa la descripción de la plantilla',
  format: 'Formato',
  retroTemplateIsPublic: 'Hacer esta plantilla pública',
  retroTemplateSave: 'Guardar Plantilla',
  retroTemplateCreate: 'Crear Plantilla de Retrospectiva',
  retroTemplateCreateSuccess: 'Plantilla de retrospectiva creada con éxito',
  retroTemplateCreateError: 'Error al crear la plantilla de retrospectiva',
  retroTemplateUpdateSuccess: 'Plantilla de retrospectiva actualizada con éxito',
  retroTemplateUpdateError: 'Error al actualizar la plantilla de retrospectiva',
  retroTemplateRemoveSuccess: 'Plantilla de retrospectiva eliminada con éxito',
  retroTemplateRemoveError: 'Error al eliminar la plantilla de retrospectiva',
  removeRetroTemplateConfirmText: '¿Estás seguro de que deseas eliminar esta plantilla de retrospectiva?',
  removeRetroTemplate: 'Eliminar Plantilla de Retrospectiva',
  retroTemplateDefault: 'Establecer como plantilla predeterminada',
  jiradatacenterLabel: 'Jira DataCenter',
  loginWithSSO: 'Iniciar sesión con {provider}',
  requestEmailChangeSuccess:
    'Solicitud de cambio de correo electrónico enviada, revise su bandeja de entrada para obtener instrucciones',
  requestEmailChangeError: 'Error al intentar cambiar el correo electrónico',
  changeEmail: 'Cambiar Correo Electrónico',
  errorChangingEmail: 'Error al intentar cambiar el correo electrónico, tal vez este enlace expiró o ya fue utilizado.',
  emailChanged: 'Correo electrónico cambiado exitosamente',
  newEmailToLogin: 'A partir de ahora, use su nuevo correo electrónico para iniciar sesión.',
  newEmail: 'Nuevo Correo Electrónico',
  enterYourNewEmail: 'Ingrese su nuevo correo electrónico',
  retroSettings: 'Retro Settings',
  enterFacilitatorCode: 'Enter the Facilitator Code',
  // Modal ariaLabels
  modalCreateAlert: 'Crear Alerta',
  modalUpdateEstimationScale: 'Actualizar Escala de Estimación',
  modalDeleteConfirmation: 'Confirmar Eliminación',
  modalCreateEstimationScale: 'Crear Escala de Estimación',
  modalTeamCheckin: 'Check-in del Equipo',
  modalAddPokerStory: 'Agregar Historia de Poker',
  modalCreateUser: 'Crear Usuario',
  modalCreateApiKey: 'Crear Clave API',
  modalImportPokerStories: 'Importar Historias de Poker',
  modalSetupMultifactorAuth: 'Configurar Autenticación Multifactor',
  modalEditPokerGame: 'Editar Juego de Poker',
  modalCreateJiraInstance: 'Crear Instancia de Jira',
  modalUpdatePokerSettings: 'Actualizar Configuración de Poker',
  modalAddStoryboardGoal: 'Agregar Objetivo del Storyboard',
  modalViewPokerStory: 'Ver Historia de Poker',
  modalStoryboardColumnSettings: 'Configuración de Columnas del Storyboard',
  modalEditStoryboard: 'Editar Storyboard',
  modalStoryboardColorLegend: 'Leyenda de Colores del Storyboard',
  modalStoryboardPersonas: 'Personas del Storyboard',
  modalRetroActionComments: 'Comentarios de Acción de Retro',
  modalStoryboardStory: 'Historia del Storyboard',
  modalTeamAddUser: 'Agregar Usuario al Equipo',
  modalCreateDepartment: 'Crear Departamento',
  modalCreateTeam: 'Crear Equipo',
  modalCreateOrganization: 'Crear Organización',
  modalCreateRetroTemplate: 'Crear Plantilla de Retro',
  modalViewRetroTemplateFormat: 'Ver Formato de Plantilla de Retro',
  modalUpdateRetroTemplate: 'Actualizar Plantilla de Retro',
  modalAssociateTeamToSubscription: 'Asociar Equipo a Suscripción',
  modalAssociateOrganizationToSubscription: 'Asociar Organización a Suscripción',
  modalTeamUpdateUser: 'Actualizar Usuario del Equipo',
  modalSubscriptionForm: 'Formulario de Suscripción',
  modalEditRetro: 'Editar Retro',
  modalEditRetroActionItem: 'Editar Elemento de Acción de Retro',
  modalRetroItemComments: 'Comentarios de Elemento de Retro',
  modalUpdateRetroSettings: 'Actualizar Configuración de Retro',
  githubRepository: 'Repositorio de GitHub',
  projects: 'Proyectos',
  projectCreate: 'Crear Proyecto',
  projectKey: 'Clave de Proyecto',
  scope: 'Ámbito',
  createdAt: 'Creado en',
  projectRemoveSuccess: 'Proyecto eliminado exitosamente',
  projectRemoveError: 'Error al eliminar el proyecto',
  removeProjectConfirmText: '¿Estás seguro de que quieres eliminar este proyecto? Esta acción no se puede deshacer.',
  removeProject: 'Eliminar Proyecto',
  modalCreateProject: 'Crear Proyecto',
  modalUpdateProject: 'Actualizar Proyecto',
  projectKeyPlaceholder: 'Ingrese la clave del proyecto (ej. PROJ)',
  projectNamePlaceholder: 'Ingrese el nombre del proyecto',
  projectDescriptionPlaceholder: 'Ingrese la descripción del proyecto (opcional)',
  projectKeyValidationError: 'La clave del proyecto debe tener 2-10 caracteres alfanuméricos',
  projectKeyHelp: '2-10 caracteres, solo letras y números',
  projectScope: 'Alcance del Proyecto',
  projectUpdate: 'Actualizar Proyecto',
  projectCreateSuccess: 'Proyecto creado exitosamente',
  projectUpdateSuccess: 'Proyecto actualizado exitosamente',
  projectCreateError: 'Error al crear el proyecto',
  projectUpdateError: 'Error al actualizar el proyecto',
  project: 'Proyecto',
  gameSettings: 'Configuración del Juego',
  endGame: 'Terminar Juego',
  endGameReason: 'Razón para Terminar el Juego',
  endGameReasonPlaceholder: 'Seleccione una razón',
  welcomeBack: 'Bienvenido de nuevo,',
  dashboardSubtitle: 'Hagamos que tu próxima sesión de colaboración en equipo sea la mejor hasta ahora.',
  filterByTeam: 'Filtrar por equipo:',
  allTeams: 'Todos los equipos',
  showContentForAllTeams: 'Mostrar contenido de todos los equipos',
  clearFilter: 'Limpiar filtro',
  teamPage: 'Página del equipo',
  dashboardTeamsRequired: 'Selecciona un equipo para ver tus sesiones de planning poker, retrospectivas y storyboards.',
  planningPokerSessions: 'Sesiones de Planning Poker',
  viewAllPokerSessions: 'Ver todas las sesiones de planning poker',
  totalPokerSessions: '{total} sesiones en total',
  noSessionsFoundForTeam: 'No se encontraron sesiones para {teamName}',
  noSessionsFound: 'No se encontraron sesiones',
  trySelectingDifferentTeamForPoker: 'Intenta seleccionar un equipo diferente o crea un nuevo juego',
  startFirstPlanningPokerSession: 'Inicia tu primera sesión de planning poker',
  sprintRetrospectives: 'Retrospectivas de Sprint',
  viewAllRetros: 'Ver todas las retrospectivas',
  totalRetros: '{total} retrospectivas en total',
  noRetrosFoundForTeam: 'No se encontraron retrospectivas para {teamName}',
  startFirstSprintRetrospective: 'Inicia tu primera retrospectiva de sprint',
  trySelectingDifferentTeamForRetros: 'Intenta seleccionar un equipo diferente o crea una nueva retrospectiva',
  viewAllStoryboards: 'Ver todos los storyboards',
  totalStoryboards: '{total} storyboards en total',
  noStoryboardsFoundForTeam: 'No se encontraron storyboards para {teamName}',
  startFirstStoryboard: 'Inicia tu primer storyboard',
  agileStoryMapping: 'Mapeo de historias ágiles',
  trySelectingDifferentTeamForStoryboards: 'Intenta seleccionar un equipo diferente o crea un nuevo storyboard',
  supportTickets: 'Tickets de Soporte',
  supportTicketDeleteConfirmation:
    '¿Estás seguro de que quieres eliminar este ticket de soporte? Esta acción no se puede deshacer.',
  supportTicketDelete: 'Eliminar Ticket',
  updateSupportTicketSuccess: 'Ticket de soporte actualizado exitosamente',
  updateSupportTicketError: 'Error al actualizar el ticket de soporte',
  getSupportTicketsError: 'Error al obtener los tickets de soporte',
  deleteSupportTicketSuccess: 'Ticket de soporte eliminado exitosamente',
  deleteSupportTicketError: 'Error al eliminar el ticket de soporte',
};

export default es;
